/// <reference path="../../lib/tsd.d.ts" />

import {TemplateEngine} from "../lib/template-engine";
export interface StdDialog
{
	title      : string;
	message    : string;
	button    ?: string;
	confirm   ?: Function;
	close     ?: Function;
	closeable ?: boolean;
}

export class DialogViewController
{
		$backDrop  : JQuery;
		$container : JQuery;

		$dialog : JQuery;
		onClose : Function;

		constructor($root : JQuery, private template : TemplateEngine)
		{
			this.$backDrop = $root.find(".sxcc-dialog-backdrop");
			this.$container = $root.find(".sxcc-dialog-wrapper");
		}

		showMsgBox(dialog : StdDialog)
		{
			var params = {
				title: dialog.title,
				message: dialog.message,
				button: dialog.button || "OK"
			};

			var $node = this.template.render("dialog-msgbox", params);

			$node.find("button.sxccd-msgbox-button").click(() => {
				this.close();
				if ("confirm" in dialog && dialog.confirm) dialog.confirm();
			});

			this.create("msgbox", $node, dialog.close);
		}

		show(id : string, params : any = {}, onClose : Function = null)
		{
			var $node = this.template.render("dialog-" + id, params);
			this.create(id, $node, onClose);
		}

		private create(name : string, $node : JQuery, onClose : Function = null)
		{
			this.onClose = onClose;

			this.$container
				.empty()
				.addClass("sxc-visible");

			this.$backDrop.addClass("sxc-visible");

			this.$dialog = $("<div />")
				.addClass("sxcc-dialog")
				.addClass("sxcc-dialog-" + name)
				.append($node)
				.appendTo(this.$container);
		}

		public dismiss()
		{
			if (this.$dialog) {
				this.$dialog.remove();
				this.$dialog = null;
				this.$backDrop.removeClass("sxc-visible");
				this.$container.empty().removeClass("sxc-visible");
			}
		}

		public close()
		{
			if (this.$dialog)
			{
				this.dismiss();
				if (this.onClose) this.onClose();
				this.onClose = null;
			}
		}

		isVisible()
		{
			return this.$dialog;
		}

		esc()
		{
			if (this.$dialog) {
				this.dismiss();
			}
		}
	}
